import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import HamburgerMenu from "./HamburgerMenu";

export default function Contact() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((open) => !open);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    // Build template params for EmailJS
    const templateParams = {
      // your form fields
      name: formData.name,
      email: formData.email,
      message: formData.message,

      // make sure the EmailJS template uses these variable names:
      // {{to_email}} as the recipient and {{reply_to}} for reply address
      to_email: "support@whatgradewillitget.com",
      reply_to: formData.email,
    };

    emailjs
      .send(
        "service_fjp40ht",          // your EmailJS service ID
        "template_6n9yegj",         // your EmailJS template ID
        templateParams,             // pass our explicit params
        "Avd-0IVCttOurJeFx"         // your public key
      )
      .then(() => {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch(() => {
        setStatus("error");
      });
  };

  const isSending = status === "sending";

  return (
    <div className="min-h-screen text-white font-[Montserrat] flex flex-col bg-black">
      {/* Header */}
      <nav
        className="flex justify-end items-center px-6 py-4 relative z-20"
        style={{ background: "rgba(0,0,0,0.0)", boxShadow: "none" }}
      >
        <div className="flex gap-3 items-center">
          <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
        </div>
      </nav>

      {/* Contact Form Section */}
      <div className="flex-grow flex items-center justify-center px-4 py-20">
        <div className="max-w-xl w-full bg-neutral-900 p-8 rounded-2xl shadow-lg">
          <h2 className="text-3xl font-bold mb-6 text-center">Contact Us</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
              className="px-4 py-3 rounded bg-neutral-800 text-white border border-neutral-700"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
              className="px-4 py-3 rounded bg-neutral-800 text-white border border-neutral-700"
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows={5}
              required
              className="px-4 py-3 rounded bg-neutral-800 text-white border border-neutral-700"
            ></textarea>

            <button
              type="submit"
              disabled={isSending}
              className={`font-semibold py-3 rounded text-white ${
                isSending
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-500"
              }`}
            >
              {isSending ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <p className="text-green-400 text-center">Message sent!</p>
            )}
            {status === "error" && (
              <p className="text-red-400 text-center">
                Something went wrong. Try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
